import type { ProgramEnrollment } from "@/features/Charting/RoomOptions/network/useEncounterTransitions";
import { createContext, useContext } from "react";

/** Fired on dialog submit; programEnrollment is set for ACCESS visits only. */
export type VisitClosureDialogCallback = (
  programEnrollment?: ProgramEnrollment,
) => void;

export type RejectAsyncVisitCallback = (args: {
  cancelReasonCode: string;
  cancelReasonText?: string;
}) => Promise<unknown>;

export type SendCarePlanCallback = () => void | Promise<void>;

export type VisitClosureDialogLaunch =
  | {
      mode: "billing";
      onSuccess: VisitClosureDialogCallback;
      visitCompleted: boolean;
    }
  | {
      mode: "rejectAsyncVisit";
      onRejectAsyncVisit: RejectAsyncVisitCallback;
    }
  | {
      mode: "billingless";
      carePlanIds: string[];
      onSendCarePlan: SendCarePlanCallback;
    };

export const VisitClosureDialogContext = createContext<{
  trigger: (launch: VisitClosureDialogLaunch) => void;
  close: () => void;
}>({
  trigger: () => {},
  close: () => {},
});

export const useVisitClosureDialog = () => {
  return useContext(VisitClosureDialogContext);
};
